import { render, staticRenderFns } from "./enrollmentservicereport.vue?vue&type=template&id=67a33738&scoped=true&"
import script from "./enrollmentservicereport.vue?vue&type=script&lang=js&"
export * from "./enrollmentservicereport.vue?vue&type=script&lang=js&"
import style0 from "./enrollmentservicereport.vue?vue&type=style&index=0&id=67a33738&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a33738",
  null
  
)

export default component.exports